import React from "react";
import { Badge, Button, Card} from "react-bootstrap";
import { CardBody } from "reactstrap";
import { withRouter } from 'react-router-dom';
import MUIDataTable from "mui-datatables";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
//import DetailsIcon from '@material-ui/icons/Details';
import UpdateIcon from '@material-ui/icons/Update';
//import DeleteIcon from '@material-ui/icons/Delete';
import {IconButton} from '@material-ui/core';
import {Tooltip} from '@material-ui/core';


class DriverList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      Data: [""],driverEdit:[],editSlot:false,remarks:"",
      partnerId: this.props.data ? this.props.data : (this.props.location.state.data ? this.props.location.state.data : '')
      ,status:""
    };
    this.nextPath = this.nextPath.bind(this);
  }


  componentDidMount() {
    const url5 = process.env.REACT_APP_NODE_ENV + "/api/drivers/getdriverbypartnerId/" + this.state.partnerId
    fetch(url5,{
      method:'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
      }
    }).then(
      response => {
        if (!response.ok) throw new Error(response.status);
        else return response.json();
      }
    ).then(data => {
		console.log(data)
      this.setState({ Data: data });
    }).catch(error => console.log(error), this.setState({ Data: [] }))
  }

  nextPath = (path, value) => {
    console.log(path);
    this.props.history.push({ pathname: path, state:{data: value} });
  }

  editStatusSlotHandler = value => {
	  console.log(value)
    const doesToggle = this.state.editSlot;

	
    this.setState({ driverEdit: value, editSlot: !doesToggle });
    this.setState({status: value.rowData[6] });
  };
  
  removeReject = value => {
    const url5 = process.env.REACT_APP_NODE_ENV + "/api/driver/remove_reject/"
	let postOrderData = {
        driverId: value.rowData[0]
      };
    fetch(url5,{
      method:'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
      },
	  body: JSON.stringify(postOrderData)
    }).then(response => {
		  window.location.reload();
      }
    ).then(data => {
		window.location.reload();
    }).catch(error => console.log(error))
	
	
  };

    handleEditFormFields = (event) => {
    //const driverEditCopy = this.state.driverEdit;
    switch (event.target.id) {
      case "statusUpdate":
        //driverEditCopy.status = event.target.value;
        this.setState({ status: event.target.value});
        break;
      case "remarks":
        this.setState({remarks:event.target.value});
        break;
        default: break;
    }
  }

  save = () => {
    this.setState({ editSlot: false })
     let postOrderData = {
        id: this.state.driverEdit.rowData[0], status: this.state.status
      };
    console.log(postOrderData);
    fetch(process.env.REACT_APP_NODE_ENV + '/api/drivers/updateDriverApp', {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
      },
      body: JSON.stringify(postOrderData)
    }).then((res) => res.json())
    .then((data) => {console.log(data);this.componentDidMount()})
    .catch((err) => console.log(err))
  };

  popUpCancel = () => {
    this.setState({editSlot:false});
  }

  // delete = (id) => {
  //   const postDriverData = {
  //     id: id
  //   };
  //   console.log(postDriverData);
  //   fetch('/api/drivers/delete', {
  //     method: 'DELETE',
  //     headers: {
  //       'Content-Type': 'application/json'
  //     },
  //     body: JSON.stringify(postDriverData)
  //   }).then(response => { if (response.ok) { this.componentDidMount() } })
  //     .then(data => console.log(data))
  //     .catch((err) => console.log(err))
  // };

  render() {

    let editSlots = null;
    if (this.state.editSlot) {
      editSlots = (
        <Modal
          isOpen={true}
          // fade={false}
          // toggle={this.to}
          style={{ width: "1200px", display: "block" }}
        >
          <Card style={{ width: "50rem" }}>
            <CardBody>
      <ModalHeader> Update Status for - {this.state.driverEdit.driverId}</ModalHeader>
              <ModalBody>
              <><div className="col-lg-4">
            <label> <b>Status</b> </label><select  id="statusUpdate"  className="form-control" value={this.state.status} onChange={this.handleEditFormFields} >
              <option value="InActive">InActive</option>
              <option value="Active">Active</option>
          </select></div>
          <div style={{paddingTop:"20px"}} className="col-lg-8">
          <input type="text" className="form-control" id="remarks" placeholder="Remarks" value={this.state.remarks} onChange={this.handleEditFormFields} />
          </div></>
              </ModalBody>
              <ModalFooter>
                <Button variant="outline-primary" onClick={() => this.save()}>
                  Save
                </Button>&nbsp;&nbsp;&nbsp;
                <Button variant="outline-danger" onClick={() =>this.popUpCancel()}> Cancel </Button>
              </ModalFooter>
            </CardBody>
          </Card>
        </Modal>
      );
    }

    let dataArr = [];
    this.state.Data.map((data) => {  
        if(data.user!==undefined){
          let variant = "";
          if(data.status === "InActive") {variant = "danger"}
          else {variant = "success"}
		  
		let reject = "";
		let rejecttext = "";
		let rejectstatus = "success";
		let rejectstatustext = "Active";
        if(data.rejectstrike === 1){
			reject = "info"
			rejecttext = "First Strike"
		}else if(data.rejectstrike === 2){
			reject = "warning"
			rejecttext = "Second Strike"
		}else if(data.rejectstrike === 3){
			reject = "danger"
			rejecttext = "Third Strike"
			rejectstatus = "danger"
			rejectstatustext = "Deactivated"
		}else{
			reject = "success"
			rejecttext = "No Strike"
		}	
console.log(data)		
          let mdData = [
            data.driverId, data.firstName+' '+data.lastName,data.user.userPhoneNumber,<Badge pill variant={reject}>{rejecttext}</Badge>,<Badge pill variant={rejectstatus}>{rejectstatustext}</Badge>,<Badge pill variant={variant}>{data.status}</Badge>,data.status,data
          ];
          dataArr.push(mdData)
        }
      return null;
    });


    const columns = [
      {
        name: "id",
        label: "Id",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "name",
        label: "Name",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "mobileNumber",
        label: "Mobile Number",
        options: {
          filter: true,
          sort: true,
        }
      },
	   {
        name: "rejectstrike",
        label: "Reject Strike",
        options: {
          filter: false,
          sort: true,
        }
      },
	  {
        name: "rejectstrike1",
        label: "Vehicle Attach Status",
        options: {
          filter: false,
          sort: true,
        }
      },
      {
        name: "status",
        label: "Status",
        options: {
          filter: false,
          sort: true,
        }
      },
      {
        name: "actions",
        label: "Actions",
        options: {
          filter: false,
          sort: false,
          customBodyRender: (value, tableMeta, updateValue) => {
            return (
              <>
			 
               <Tooltip title="Details"><IconButton>
			   <button onClick={() => this.nextPath("/partner/driver/driver-details", tableMeta.rowData[0])}>D</button> </IconButton></Tooltip>
			  <Tooltip title="Remove Reject Strike"><IconButton>
			  <button onClick={() => this.removeReject(tableMeta)}>RS</button> </IconButton></Tooltip>
              <Tooltip title="Update Status"><IconButton>
              <UpdateIcon onClick={() => this.editStatusSlotHandler(tableMeta)} /></IconButton></Tooltip>
              </>
            );
          }
        }
      }
    ];


    const options = {
      filterType: "textField",
      fixedHeader: true,
      sort: true,
      search: true,
      selectableRows: false,
      responsive: "scroll",
      rowsPerPage: 15,
      rowHove: true,
      selectableRowsHeader: true,
      expandableRows: false,
      expandableRowsOnClick: false
      // ,
      // onRowsDelete: (rowsDeleted) => {
      //   for (var key in rowsDeleted.data) {
      //     console.log(rowsDeleted.data[key].index)
      //     this.delete(dataArr[rowsDeleted.data[key].index].id)
      //   }
      // }
    };


    return (
      <>
        <Card>
          <Card.Body>
          <Button className="float-right"
                    variant="outline-success"
                    style={{ marginTop: "25px", width: "150px", marginRight:"20px"}}
                    onClick={() => this.nextPath("/partner/driver/driver-create", this.props.data)}>
                    Add Driver
                  </Button>
            <div style={{ marginTop: "10px" }}>
              {editSlots}
              <MUIDataTable
                title={"Driver List"}
                data={dataArr}
                columns={columns}
                options={options} />
            </div>
          </Card.Body>
        </Card>
      </>
    );
  }
}

export default withRouter(DriverList);
